import { Avatar } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const smallScreenGridColumnWidth = '130px';
export const gridColumnWidth = '140px';
export const gridArrowColumnWidth = '120px';
export const smallScreenGridArrowColumnWidth = '58px';

export interface CrewTreeContainerStyledProps {
  nodeCount: number;
  showAffectedNode?: boolean;
}

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

function getLayoutStyle({ ...props }: CrewTreeContainerStyledProps) {
  if (props.showAffectedNode) {
    return css`
      grid-template-rows: 32px repeat(${props.nodeCount * 2 - 1}, auto);
      grid-template-columns: ${gridColumnWidth} ${gridArrowColumnWidth};
      @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
        grid-template-columns: ${smallScreenGridColumnWidth} ${smallScreenGridArrowColumnWidth};
      }
    `;
  } else {
    return css`
      grid-template-rows: 32px repeat(${props.nodeCount * 2 - 1}, auto);
      grid-template-columns: ${gridColumnWidth};
      @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
        grid-template-columns: ${smallScreenGridColumnWidth};
      }
    `;
  }
}

export const HrStyled = styled.hr`
  ${({ theme }) => css`
    border: none;
    border-top: 1px dashed ${theme.colors.grey[700]};
    height: 1px;
    width: 100%;
    margin-top: calc(${theme.spacings[300]} + ${theme.spacings[100]} / 2);
  `};
`;

export const ArrowStyled = styled.div`
  ${({ theme }) => css`
    width: 0;
    height: 0;
    border-top: ${theme.spacings[400]} solid transparent;
    border-bottom: ${theme.spacings[400]} solid transparent;
    border-left: ${theme.spacings[400]} solid ${theme.colors.grey[700]};
  `};
`;
export const CrewTreeContainerStyled = styled.div<CrewTreeContainerStyledProps>`
  display: grid;
  ${getLayoutStyle};
`;

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
